import React from 'react';

const HeaderImageSVG = (props) => (
    <svg width="100%" height="80%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="40" width="100%" height="80%" rx="10" fill={props.fill}/>
    </svg>
)

export default HeaderImageSVG;